import { useCallback } from "react";
import { useSavePromotionMutation } from "../mutations/useSavePromotion.mutation";
import { PromotionType } from "../../../interfaces/promotionType";

export const useSavePromotion = () => {
  const saveMutation = useSavePromotionMutation();

  const handleSave = useCallback(
    (values: PromotionType) => {
      saveMutation.mutate(values);
    },
    [saveMutation],
  );

  return {
    handleSave,
    isSaving: saveMutation.isPending,
  };
};
